
import { Vue, Component, Ref } from 'vue-property-decorator';
import WorkbenchesService from '@/services/workbenches.service';
import lazyInject from '@/di';
import LookGoodDrawer from '@/views/workbenches/subassembly/LookGoodDrawer.vue';

@Component({
  components: {
    LookGoodDrawer,
  },
})
export default class LookCPSShopDrawer extends Vue {
  visible = false;

  @lazyInject(WorkbenchesService)
  workbenchesService!: WorkbenchesService;

  @Ref()
  lookGoodDrawer!: LookGoodDrawer;

  data: any = [];


  filterForm: any = {
    shop_name: '',
    poi: '',
  };

  columns = [
    {
      title: '门店名称',
      dataIndex: 'shop_name',
      key: 'shop_name',
      align: 'center',
      width: '200px',
      scopedSlots: { customRender: 'shop_name' },
    },
    {
      title: 'poi',
      dataIndex: 'poi',
      key: 'poi',
      align: 'center',
      width: '200px',
    },
    {
      title: '活动数量',
      dataIndex: 'goods_num',
      key: 'goods_num',
      align: 'center',
      width: '200px',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      scopedSlots: { customRender: 'action' },
      align: 'center',
      width: 100,
    },
  ];

  title = '查看店铺';

  userId: any = '';

  async init(val: any) {
    this.userId = val.user_id;
    this.getCpsShopList();
  }

  pagination: any = {
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    onShowSizeChange: this.onShowSizeChange,
    onChange: this.onChange,
  };


  search() {
    this.pagination.current = 1;
    this.getCpsShopList();
  }
  resetQuery() {
    this.filterForm = {
      shop_name: '',
      poi: '',
    };
    this.pagination.current = 1;
    this.getCpsShopList();
  }

  onShowSizeChange(current: number, size: number) {
    this.pagination.current = 1;
    this.pagination.pageSize = size;
    this.getCpsShopList();
  }

  async onChange(current: number, size: number) {
    this.pagination.current = current;
    this.pagination.pageSize = size;
    this.getCpsShopList();
  }

  async getCpsShopList() {
    const params = {
      user_id: this.userId,
      month: this.$route.query.month,
      page: this.pagination.current,
      pageSize: this.pagination.pageSize,
      shop_name: this.filterForm.shop_name,
      poi: this.filterForm.poi,
    };
    const res = await this.workbenchesService.getCpsShops(params);
    if (res) {
      this.visible = true;
      this.data = res.list;
      this.pagination.total = res.total;
    }
  }

  goToShopDetail(id: string) {
    const routeUrl = this.$router.resolve({
      name: 'main.shop.detail',
      params: {
        id: `${id}`,
      },
    });
    window.open(routeUrl.href, '_blank');
  }

  lookGoods(row: any) {
    const data = {
      shop_id: row.shop_id,
      user_id: this.userId,
    };
    this.lookGoodDrawer.init(data);
  }

  onClose() {
    this.visible = false;
  }
}
